import { render, staticRenderFns } from "./sba-icon-button.vue?vue&type=template&id=aa0b2a9e&"
import script from "./sba-icon-button.vue?vue&type=script&lang=js&"
export * from "./sba-icon-button.vue?vue&type=script&lang=js&"
import style0 from "./sba-icon-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports